import { render, staticRenderFns } from "./SfxSearchForm.vue?vue&type=template&id=646c9368&scoped=true"
import script from "./SfxSearchForm.vue?vue&type=script&lang=js"
export * from "./SfxSearchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c9368",
  null
  
)

export default component.exports